import React from 'react';
import LegalPage from './home/LegalPage';

const CookiesPolicy = () => <LegalPage page="cookies" path="/cookies" testId="cookies-page" />;

export default CookiesPolicy;
